<template>
  <div class="page-content zizhiAuthJigou" :style="defaultHeight" id="page-content">
    <div class="startTitle">机构入驻</div>
    <el-row>
      <el-col :span="16" :offset="4">
          <ul class="stepBox">
             <li class="stepText">
               <img src="../../assets/images/back/step.png" alt="">
               <span class="act">基本信息</span>
             </li>
             <li class="stepLine"></li>
            <li class="stepText">
              <img src="../../assets/images/back/stepno.png" alt="">
              <span>相关资质</span>
            </li>
            <li class="stepLine"></li>
            <li class="stepText">
              <img src="../../assets/images/back/stepno.png" alt="">
              <span>提交审核</span>
            </li>
          </ul>
      </el-col>
    </el-row>
    <el-row style="padding-top: 40px">
      <el-col :span="13" :offset="5" >
          <!--  基本信息      -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="公司名称" prop="gsname">
            <el-input v-model="ruleForm.gsname" placeholder="请输入公司名称" style=""></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="legalRepresentative">
            <el-input v-model="ruleForm.legalRepresentative"  placeholder="请输入法定代表人"></el-input>
          </el-form-item>
          <el-form-item label="组织机构代码" prop="organizationCode">
            <el-input v-model="ruleForm.organizationCode"  placeholder="请输入组织机构代码"></el-input>
          </el-form-item>
          <el-form-item label="注册资金" prop="regCapital">
            <el-input style="width: 220px" v-model="ruleForm.regCapital"  placeholder="请输入注册资金"></el-input>
            <span>万元</span>
          </el-form-item>
          <el-form-item label="所属行业" prop="industry">
            <el-select style="width: 220px" v-model="ruleForm.industry" placeholder="请选择所属行业">
              <el-option v-for="item in getIndustryList" :label="item.tradeCategory" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="detailAddress">
            <el-input v-model="ruleForm.detailAddress"  placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="所在城市">
            <el-select v-model="prov" @change="getCityAddress" style="width:140px;margin-right: 25px;">
              <el-option v-for="dict in productList" :key="dict.projectIdentification" :label="dict.label" :value="dict.value" />
            </el-select>
            <el-select v-model="city" style="width:140px;margin-right: 27px;"  @change="getCountyAddress">
              <el-option v-for="dict in cityList" :key="dict.projectIdentification" :label="dict.label" :value="dict.value" />
            </el-select>
            <el-select v-model="district" v-if="district" style="width:140px;">
              <el-option v-for="dict in countyList" :key="dict.projectIdentification" :label="dict.label" :value="dict.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="经营范围" prop="businessScope">
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 1000}" v-model="ruleForm.businessScope"  placeholder="请输入，文字内容10-1000字"></el-input>
          </el-form-item>
          <el-form-item label="主营产品" prop="mainProducts">
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 1000}" v-model="ruleForm.mainProducts"  placeholder="请填写主营产品"></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="remark">
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 1000}" v-model="ruleForm.remark"  placeholder="请填写简介"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success"  class="btn-submit" @click="submitForm('ruleForm')">提交</el-button>

          </el-form-item>
        </el-form>
          <!--  基本信息      -->
          <!--  相关资质      -->

          <!--  相关资质      -->
      </el-col>
    </el-row>
  </div>
</template>


<script>
    import '@/assets/css/backcommon.css'
    import Cookies from 'js-cookie'
    import {
        mechanismSettleIn,
        mechanismSaveMechanismInfo,
        getProductAddress,
        getCityAddress,
        mechanismGetIndustryList
    } from '@/api/myInfo'
    export default {
        name: "zizhiAuthJigou_jbxx",
        data() {
            return {
                id:"",
                defaultHeight: {
                    height: ""
                },
                isModifyData:"",
                userId:'',
                //所属行业
                getIndustryList:"",
                // 省份
                productList: null,
                // 市份
                cityList: null,
                // 区县
                countyList: null,
                prov: '请选择',
                city: '请选择',
                district: '请选择',
                cityArr: [],
                districtArr: [],
                ruleForm: {
                    gsname:"",
                    legalRepresentative:"",
                    organizationCode:"",
                    regCapital:"",
                    industry:"",
                    detailAddress:"",
                    businessScope:"",
                    mainProducts:"",
                    remark:""
                },
                rules:{
                    gsname:[
                        { required: true, message: '请输入公司名称', trigger: 'blur' },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    legalRepresentative:[
                        { required: true, message: '请输入法定代表人', trigger: 'blur' },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    organizationCode:[
                        { required: true, message: '请输入组织机构代码', trigger: 'blur' },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    regCapital:[
                        { required: true, message: '请输入注册资金', trigger: 'blur' },
                    ],
                    industry: [
                        { required: true, message: '请选择所属行业', trigger: 'change' }
                    ],
                    detailAddress:[
                        { required: true, message: '请输入详细地址', trigger: 'blur' },
                    ],
                    businessScope:[
                        { required: true, message: '请输入，文字内容10-1000字', trigger: 'blur' },
                    ],
                    mainProducts:[
                        // { required: true, message: '请填写主营产品', trigger: 'blur' },
                    ],
                    remark:[]
                }


            }
        },
        components: {},
        beforeMount() {
            this.userId=this.$store.state.user.userId;
            if(this.userId===""){
                console.log(Cookies.get("userInfo"));
                this.userId=JSON.parse(Cookies.get("userInfo"))["userId"];
            }
            var isModifyData=this.$router.currentRoute.query.isModifyData;
            if(isModifyData==undefined){
                this.isModifyData="false";
            }else{
                this.isModifyData="true";
            }
            this.getProductAddress();
            this.mechanismGetIndustryList();
            this.mechanismSettleIn();
        },
        mounted(){
            //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
            window.addEventListener("resize", this.getHeight);
            this.getHeight();
        },
        watch: {

        },
        methods: {
            //定义方法，获取高度减去头尾
            getHeight() {
                this.defaultHeight.height = document.getElementById("page-content") - 106 + "px";
            },
            submitAjax(){

                var data={
                    id:this.id,
                    companyName:this.ruleForm.gsname,
                    representative:this.ruleForm.legalRepresentative,
                    organizationCode:this.ruleForm.organizationCode,
                    registeredCapital:this.ruleForm.regCapital,
                    industry:this.ruleForm.industry,
                    detailedAddress:this.ruleForm.detailAddress,
                    projectSecverProvince: this.prov,
                    projectSecverCity: this.city,
                    projectSecverCounty: this.district,
                    businessScope:this.ruleForm.businessScope,
                    mainProducts:this.ruleForm.mainProducts,
                    remark:this.ruleForm.remark
                };
                var ths=this;
                mechanismSaveMechanismInfo(data).then(res=>{
                    console.log("-----------------------");
                    if (parseFloat(res.data.code)=== 200) {
                        this.message("提交成功",'success');
                        setTimeout(function () {
                            var id=res.data.msg;
                            var str='';
                            if(ths.isModifyData==="true"){
                                str="&isModifyData=true"
                            }

                            ths.$router.push("/personCenter/zizhiAuth/zizhiAuthJigou_xgzz?id="+id+str);
                        },1000);
                    } else {
                        this.message(res.data.msg);
                    }
                });
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitAjax();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 获取省份
            getProductAddress () {
                getProductAddress().then(response => {
                    this.productList = response.data.data;
                });
            },
            // 获取市
            getCityAddress (value) {
                console.log(value)
                var param = { "cityName": value, "cityType": 2 };
                getCityAddress(param).then(response => {
                    this.cityList = response.data.data;
                });
            },
            // 获取区县
            getCountyAddress (value) {
                console.log(value)
                var param = { "cityName": value, "cityType": 3 };
                getCityAddress(param).then(response => {
                    this.countyList = response.data.data;
                });
            },
            //所属行业
            mechanismGetIndustryList(){
                mechanismGetIndustryList(0).then(response => {
                    this.getIndustryList = response.data.data;
                });
            },
            setData(ths,data){
                    ths.ruleForm.gsname=data.companyName;
                    ths.ruleForm.legalRepresentative=data.representative;
                    ths.ruleForm.organizationCode=data.organizationCode;
                    ths.ruleForm.regCapital=data.registeredCapital;
                    ths.ruleForm.industry=data.industry;
                    ths.ruleForm.detailAddress=data.detailedAddress;
                    ths.prov=data.projectSecverProvince;
                    getCityAddress({"cityName": data.projectSecverCity, "cityType": 2}).then(response => {
                        ths.cityList = response.data.data;
                        ths.city = data.projectSecverCity;
                        getCityAddress({"cityName": data.projectSecverCity, "cityType": 3}).then(response => {
                            ths.countyList = response.data.data;
                            ths.district = data.projectSecverCounty;
                        });
                    });
                    ths.ruleForm.businessScope=data.businessScope;
                    ths.ruleForm.mainProducts=data.mainProducts;
                    ths.ruleForm.remark=data.remark;
            },
            mechanismSettleIn(){
                var ths=this;
                mechanismSettleIn(this.userId).then((res)=>{
                    console.log(res);
                    if (parseFloat(res.data.code)=== 200) {
                        //是否已经提交
                        if(res.data.data===""||res.data.data===undefined||res.data.data===null){
                            ths.id='';
                            return;
                        }else if(parseInt(res.data.data.status)===0){//审核中
                            ths.id=res.data.data.id;
                            ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
                        }else if(parseInt(res.data.data.status)===1){//  审核成功  有userInfo数据吗
                            //ths.message("审核已通过");
                            //ths.setData(ths,res.data.data);
                            ths.id=res.data.data.id;
                            ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
                        }else if(parseInt(res.data.data.status)===2){//审核失败   需要修改true就修改数据
                            ths.id=res.data.data.id;
                            if(this.isModifyData==="false"){
                                ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
                                return;
                            }
                            ths.message("审核未通过,请重新填写信息");
                            //需要修改true就回显数据
                            ths.setData(ths,res.data.data);
                        }
                    } else {
                        ths.message(res.data.msg);
                    }
                })
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/personCenter/zizhiAuthJigou_jbxx.vue